import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector,useDispatch } from 'react-redux';
import {
	CCard,
	CCardHeader,
	CRow,
	CCol,
	CCardBody,
	CCardFooter,
	CTooltip,
	CLink,
	CForm,
	CFormInput,
} from '@coreui/react';
//import CIcon from '@coreui/icons-react';
import {
	MyFormHapus,MyPage500,MyPagination
} from '../components/index';
import { UFunc } from "../helpers/functions";
import { Konfirm } from '../helpers/onConfirm';
import NumberFormat from 'react-number-format';
import { isMobile } from "react-device-detect";

const pjson     	= require('../../package.json');
const Kastransfer 	= (props) => {
	const uComponentname 	= Kastransfer.name;
	const { 
		prosesExpired, setLoading, showToast, setSessionaktif 
	} = props; 

	let uFuncname;
	const uNavigate  	= useNavigate();
	const uDispatch		= useDispatch();

	const uTokenObj		= JSON.parse(localStorage.getItem("token"));
	const uBahasaObj  	= useSelector(state => state.listBahasa);
	const uActiveroute  = useSelector(state => state.activeRoute);
	const uEfekapp		= useSelector(state => state.effectApp);
	const [uEfekview,setEfekview] = React.useState(false);
	const uHTMLstyleTabel	= useSelector(state => state.gHTMLstyleLaporan);
	const uIsScrollBottom	= useSelector(state => state.gIsScrollBottom);
	const uTabelSelectObj	= useSelector(state => state.gInitTabelSelected);
	const uIsEOMExecuted	= useSelector(state => state.gIsEOMExecuted);

	//---VAR_GLOBALS--/
	const uSettingObj 		= useSelector(state => state.gListUserSetting);
	const uIsAllowedhapus	= (uTokenObj.userhak==="FREEROLE" || uTokenObj.userhak==="ADMIN") && uIsEOMExecuted
	const uIsInitbefore 	= ((JSON.stringify(uTabelSelectObj)||"{}")!=="{}");
	const [uInitbeforeprocess,setInitbeforeprocess] = React.useState(false);

	const uKeywordObj		= JSON.parse(localStorage.getItem("listkeyword")) || {};
	const uHeaderActionObj  = useSelector(state => state.gInitHeaderAction);
	const uHandelView 		= uHeaderActionObj.isHeaderView || false;
	const uHandelTambah 	= uHeaderActionObj.isHeaderTambah || false;

	const uMaxData							= isMobile ? (uSettingObj.jml_mobile || 20) : (uSettingObj.jml_laporan || 100);
	const [uHTMLError500,setHTMLError500]	= React.useState();
	const [uDatamainArr,setDatamainArr]		= React.useState([]);
	const [uPageActive,setPageActive]		= React.useState(1);
	const [uJmlData,setJmlData] 			= React.useState(0);
	const [uJmlHal,setJmlHal] 				= React.useState(1);
	const [uTabelRowSelect,setTabelRowSelect]= React.useState(-1);
	const [uTimeElapsed,setTimeElapsed]		= React.useState(0);
	const [uFirstload,setFirstload]			= React.useState("YA");

	const [isShowForm,setShowForm]			= React.useState(false);
	const [uDialogHeader,setDialogHeader]	= React.useState("");
	const [uTabelIDPilih,setTabelIDPilih]	= React.useState(0);
	const [uInpKeterangan,setInpKeterangan]	= React.useState("");

	const [uElBtndlgsimpan,setElBtndlgsimpan]= React.useState(document.getElementById("btnDialogSimpan"));
	const uElJmldata		= document.getElementById("idjmldata");
	//---END VAR_GLOBALS--/

	//---HANDLE--/
	const hdlToggleForm=()=>{ setShowForm(false); }
	const hdlKlikHapus=(_IDTABEL)=>{
		_IDTABEL = parseInt(_IDTABEL) || 0;
		if(_IDTABEL <= 0) return;

		var vObjdx	= UFunc.getObjectIndeks(uDatamainArr,_IDTABEL);
		var vRowIdx	= UFunc.getTabelRowIndeks("idtabeldata","idtr"+_IDTABEL);
		setTabelRowSelect(vRowIdx);
		setTabelIDPilih(_IDTABEL);
		
		setDialogHeader((uBahasaObj.caption_hapusdata||"caption_hapusdata")+": "+
			(UFunc.HariAngka(uDatamainArr[vObjdx].tanggal)+" "+(uDatamainArr[vObjdx].gl_kredit_caption || "")).toUpperCase());
		setShowForm(true);
	}
	const hdlKlikSimpanHapus=()=>{
		if((uInpKeterangan||"").trim() === "") {
			showToast((uBahasaObj.pesan_penghapusanharusdiisi||"pesan_penghapusanharusdiisi")); 
			if(!isMobile)
				document.getElementById("inpketerangan") &&
					document.getElementById("inpketerangan").focus();
			return;
		}

		apiHapus();
	}
	//---END HANDLE--/

	//---Init_LOAD--/
	const initReset = () => {
		setJmlData(0);
		setDatamainArr([]);
		setTabelRowSelect(-1);
		setPageActive(1);
	}
	const initJmldata = () => {
		const vKeyword = uKeywordObj.kwd_kastransfer || "";
		if(vKeyword.length < 3) {
			uElJmldata && (uElJmldata.innerHTML = "&#8734;");
			return;
		}//-*/
		uElJmldata && (uElJmldata.innerHTML = UFunc.formatAngka(uJmlData));
	}
	const initFormAwal = () => {
		setTabelIDPilih(0);

		setInpKeterangan("");
	}

	const contentMain = () => {
		if(uHTMLError500) return ""

		const vMin			= (uPageActive-1)*uMaxData;
		const vMax			= (vMin+uMaxData);
		let vNumber			= (vMin);
		let vCaptionUpper	= "";
		const vKeyword 		= UFunc.filterRegex(uKeywordObj.kwd_kastransfer || "");
		const vKeywordcolor = uSettingObj.color_keyword;
		const vReplace 		= new RegExp(vKeyword,"ig");

		//const vDataViewObj	= isMobile ? uDatamainArr.slice(0,(vMax+1)) : uDatamainArr.slice(vMin,(vMax+1));
		const vDataViewObj	= uDatamainArr.filter(vItems=> parseInt(vItems.pg||1)===parseInt(uPageActive||1))
		//console.log("("+uComponentname+" - contentMain) vDataViewObj : "+JSON.stringify(vDataViewObj));
		
		return (
		<table className="table table-borderless table-striped table-hover" id="idtabeldata">
		<thead>
		<tr className="d-none d-md-table-row text-center align-top classfontsmaller">
		<th width="5%" className="px-1">No</th>
		<th className="px-1">
			<CRow className="mx-1">
			<CCol md="2" lg="3" className="text-start">{uBahasaObj.word_tanggal||"word_tanggal"}</CCol>
			<CCol md="3" className="text-start">{uBahasaObj.caption_aruskas||"caption_aruskas"}</CCol>
			<CCol md="4" className="text-start">{uBahasaObj.word_keterangan||"word_keterangan"}</CCol>
			<CCol md="2" lg="1" className="">{uBahasaObj.word_nilai||"word_nilai"} (Rp)</CCol>
			<CCol md="1" className="">&middot;</CCol>
			</CRow>
		</th>
		</tr>
		</thead>
		<tbody>
		{vDataViewObj.map((vItems,vKeys)=>{
			const {
				id,tanggal,tgl_input,gl_debet_caption,gl_debet_id,status_jurnal,
				gl_kredit_caption,gl_kredit_id,username,init_expired,
				keterangan,noref,nilai
			} = vItems;

			vNumber++;
			vCaptionUpper	= (UFunc.HariAngka(tanggal)+" "+gl_kredit_caption).toUpperCase();

			const vTanggal	= vKeyword==="" ? UFunc.HariAngka(tanggal) 
				: (UFunc.HariAngka(tanggal)).replace(vReplace,"<strong><U style='color:"+vKeywordcolor+"'>"+vKeyword.toUpperCase()+"</U></strong>");
			const vDebetCaption= vKeyword==="" ? (gl_debet_caption||"") 
				: (gl_debet_caption||"").replace(vReplace,"<strong><U style='color:"+vKeywordcolor+"'>"+vKeyword.toUpperCase()+"</U></strong>");
			const vKreditCaption= vKeyword==="" ? (gl_kredit_caption||"") 
				: (gl_kredit_caption||"").replace(vReplace,"<strong><U style='color:"+vKeywordcolor+"'>"+vKeyword.toUpperCase()+"</U></strong>");
			const vUsername= vKeyword==="" ? (username||"") 
				: (username||"").replace(vReplace,"<strong><U style='color:"+vKeywordcolor+"'>"+vKeyword.toUpperCase()+"</U></strong>");
			const vKeterangan= vKeyword==="" ? (keterangan||"") 
				: (keterangan||"").replace(vReplace,"<strong><U style='color:"+vKeywordcolor+"'>"+vKeyword.toUpperCase()+"</U></strong>");
			const vNoref= vKeyword==="" ? (noref||"") 
				: (noref||"").replace(vReplace,"<strong><U style='color:"+vKeywordcolor+"'>"+vKeyword.toUpperCase()+"</U></strong>");
			const vTglInput	= vKeyword==="" ? UFunc.WaktuAngka(tgl_input) 
				: (UFunc.WaktuAngka(tgl_input)).replace(vReplace,"<strong><U style='color:"+vKeywordcolor+"'>"+vKeyword.toUpperCase()+"</U></strong>");
			
			const vColorstatustembak = (status_jurnal||"")==="TEMBAK" ? "text-primary" : "";

			const vArusGL	= 
				//(uBahasaObj.word_dari||"word_dari")+": "+
				"<b class='fst-italic'>"+vKreditCaption+"</b>"+
				"-"+(uBahasaObj.word_ke||"word_ke").toUpperCase()+"-"+
				"<b class='fst-italic'>"+vDebetCaption+"</b>";

			return (
			<tr id={"idtr"+id} key={vKeys} className={"align-top text-end"+(uTabelRowSelect===vKeys?" classrowselect":"")}>
				<td className="px-1 pe-0">{vNumber}.</td>
				
				<td className="px-1">
				<CRow className="mx-0">
				<CCol md="2" lg="3" className="px-1 text-md-start">
					<div className="d-flex justify-content-between">
					<div>
					{UFunc.renderHTML(vTanggal)}
					{uTokenObj.userhak==="FREEROLE" && (
						<span className="classfontsmaller">
						<small> &middot; ({id})</small>
						</span>
					)}
					</div>
					
					{uIsAllowedhapus && (
					<div className="d-md-none">
					<CLink 
						className="classcursorpointer classikontabel classikonhapus"
						onClick={()=>hdlKlikHapus(id)} />
					</div>
					)}

					</div>

					<div className="classfontsmaller text-danger d-none d-md-block">
						<small>[
						{((tgl_input||"").trim()!=="") && (
						<>
						{UFunc.renderHTML(vTglInput)}
						<span className="mx-1">&middot;</span>
						</>
						)}
						{UFunc.renderHTML(vUsername.toUpperCase())}
						]</small>
					</div>
				</CCol>
				
				<CCol xs="12" className="classborderbottom my-2 d-md-none"/>

				<CCol xs="4" className="px-1 text-start d-md-none">Arus Kas</CCol>
				<CCol xs="8" md="3" className="px-1 text-md-start">
					<div className="text-info">{UFunc.renderHTML(vArusGL)}</div>

					{(uTokenObj.userhak==="FREEROLE" && (status_jurnal||"")!=="") && (
						<div className="classfontsmaller d-none d-md-block">
						<small>&middot; S.Jurnal: <b>{status_jurnal}</b> &middot;</small>
						</div>
					)}
				</CCol>

				{(uTokenObj.userhak==="FREEROLE") && (
				<>
				<CCol xs="4" className="d-md-none px-1 text-start classfontsmaller">{uBahasaObj.caption_sjurnal||"S.Jurnal"}</CCol>
				<CCol xs="8" className={"px-1 d-md-none classfontsmaller "+vColorstatustembak}>
					<b>{status_jurnal || "-"}</b>
				</CCol>
				</>
				)}

				<CCol xs="4" className="px-1 text-start d-md-none">Keterangan</CCol>
				<CCol xs="8" md="4" className="text-md-start px-1">
					<small className="fst-italic">{UFunc.renderHTML(vKeterangan)}</small>
					{(noref||"").trim() !== "" ? (
					<div className="text-primary d-none d-md-block">
						No.REF: <b>{UFunc.renderHTML(vNoref)}</b>
					</div>
					) : (
					<>
						{(keterangan||"").trim() !== "" && (<>-</>)}
					</>
					)}
				</CCol>
				
				{(noref||"").trim() !== "" && (
				<>
				<CCol xs="4" className="px-1 text-start d-md-none">No.REF</CCol>
				<CCol xs="8" className="px-1 d-md-none">
					<b className="text-primary">{UFunc.renderHTML(vNoref)}</b>
				</CCol>
				</>
				)}

				<CCol xs="4" className="px-1 text-start d-md-none">{uBahasaObj.caption_inputby||"Inputby"}</CCol>
				<CCol xs="8" className="px-1 d-md-none">
					<div className="text-danger">
						<small>[
						{((tgl_input||"").trim()!=="") && (
						<>
						{UFunc.renderHTML(vTglInput)}
						<span className="mx-1">&middot;</span>
						</>
						)}
						{UFunc.renderHTML(vUsername.toUpperCase())}
						]</small>
					</div>
				</CCol>

				<CCol xs="12" className="classborderbottom my-2 d-md-none"/>
				<CCol xs="4" className="px-1 text-start d-md-none">{uBahasaObj.word_nilai||"word_nilai"} (Rp)</CCol>
				<CCol xs="8" md="2" lg="1" className="px-1">
					<b className="text-success">{UFunc.formatAngka(nilai)}</b>
				</CCol>

				<CCol md="1" className="px-1 text-md-center d-none d-md-block">
					{(uIsAllowedhapus && (init_expired||"YA")==="TIDAK") ? (
					<CTooltip content={"--"+(uBahasaObj.caption_hapusdata||"caption_hapusdata")+": "+vCaptionUpper}>
					<CLink 
						className="classcursorpointer classikontabel classikonhapus"
						onClick={()=>hdlKlikHapus(id)} />
					</CTooltip>
					) : (<>&middot;</>)}
				</CCol>
				</CRow>
				</td>
			</tr>
			)
		})}
		</tbody>
		</table>
		)//>
	}
	const contentFormhapus = () => {
		return (
			<>
			<CForm className="mx-md-2 mx-lg-4">
			<CRow className="my-2">
				<CCol className="">
					{uBahasaObj.caption_alasanpenghapusan||"caption_alasanpenghapusan"}
					<CFormInput maxLength="255"
						type="text"
						size="sm"
						className="form-control text-capitalize"
						value={uInpKeterangan}
						onChange={(e) => setInpKeterangan(e.target.value)}
						onKeyDown={(e)=> UFunc.hdlKeyDownInput(e,"btnDialogSimpan")}
						id="inpketerangan"/>
				</CCol>
			</CRow>

			<CRow className="my-3"><CCol className="classborderbottom"/></CRow>

			<CRow className="my-2">
				<CCol className="">
				{(uBahasaObj.petunjuk_hapus||"petunjuk_hapus")}
				</CCol>
			</CRow>

			<CRow className="my-2"/>
			<CRow className="my-2">
				<CCol className="">
				<strong>
					{(uBahasaObj.confirm_hapus||"confirm_hapus")}
				</strong>
				</CCol>
			</CRow>
			</CForm>
			</>
		)//>
	}
	//---END Init_LOAD--/

	//---API_FUNC--/
	const apiLoaddata = (_PAGE) => {
		uFuncname 	= apiLoaddata.name;
		_PAGE		= parseInt(_PAGE)||1;
		setHTMLError500();

		const vKeyword 		= uKeywordObj.kwd_kastransfer || "";
		const vHandelview	= ((uHandelView||false)===true || uFirstload==="YA")
			?"YA":"TIDAK";
		let vDatamainArr 	= uDatamainArr;
		if(vHandelview==="YA") {
			vDatamainArr	= [];
		} else {
			if(uDatamainArr.length >= 10000) {
				vDatamainArr	= uDatamainArr.filter(vItems=>parseInt(vItems.pg||1)===1);
			} else {
				vDatamainArr	= uDatamainArr.filter(vItems=>parseInt(vItems.pg||1)!==_PAGE);
			}
		}
		setLoading(true);

		/*//--TESTING_FRONTEND--/
		//--END TESTING_FRONTEND--*/

		const vDATAS	= JSON.stringify({
			send_keyword : vKeyword,
			send_pg: _PAGE,
			send_maxdata	: uMaxData,
			send_loadjml	: vHandelview,
			send_tokenauth : uTokenObj.userinit
		});
		const vURLs	= pjson.homepage+"api/api_kastransfer/ld_data";

		setTimeElapsed(0);
		const vTimeBegin = new Date();
		setLoading(true);
		fetch(vURLs,{
			headers: { Accept: "application/json", "Content-Type": "application/json" },
			method: "POST",
			mode: "cors",
			cache: "default",
			body: vDATAS,
		}).then((response)=> { if (response.status === 200) {setSessionaktif(false); return response.json();} })
		.then((output_string) => {
			setSessionaktif(true);
			setLoading(false);
			//console.log("("+uComponentname+"-"+uFuncname+") output_string : "+JSON.stringify(output_string.errors));
			if(output_string.tampil) {
				let vTmpObj = JSON.parse(output_string.dataobject||"[]");
				vTmpObj.map(vItems=>vItems.pg = _PAGE);

				setDatamainArr([...vDatamainArr,...vTmpObj]);
				if(vKeyword.length >= 3)
					setJmlData(parseInt(output_string.totaldata||uJmlData))
				else setJmlData(vTmpObj.length);

				if(uIsInitbefore) {
					setInitbeforeprocess(true)
				}
				setFirstload("TIDAK");

				const vTimeEnd = new Date();
				const vTimeDiff = vTimeEnd - vTimeBegin; //in ms
				setTimeElapsed(vTimeDiff);
			} else if(output_string.info) {
				setHTMLError500(output_string.info);
			} else if(output_string.errors) {
				console.log("("+uComponentname+"-"+uFuncname+") output_string.errors : "+output_string.errors);
				const vMsg = (pjson.mydefault.environment==="development")
					? output_string.errors : pjson.mydefault.msgFetchError;
				setHTMLError500("<font color='red'>"+vMsg+"</font>");
			} else if(output_string.expired) {
				prosesExpired();
			}
		})
		.catch((error) =>{
			setLoading(false);
			console.log("("+uComponentname+"-"+uFuncname+") catch-error: "+error);
			setHTMLError500(pjson.mydefault.msg500str.join(" "));
		});
	}
	const apiHapus = () => {
		uFuncname 	= apiHapus.name;
		if(uTabelIDPilih <= 0) {showToast("[0] ERROR !"); return;}
		const vObjdx= UFunc.getObjectIndeks(uDatamainArr,uTabelIDPilih);

		setLoading(true);
		uElBtndlgsimpan.disabled = true;

		/*//---TESTING_FRONTEND--/
		//---END TESTING_FRONTEND--*/

		const vDATAS	= JSON.stringify({
			send_tabelid : uTabelIDPilih,
			send_kethapus : uInpKeterangan,
			send_tokenauth : uTokenObj.userinit
		});
		const vURLs	= pjson.homepage+"api/api_kastransfer/pr_hapus";

		fetch(vURLs,{
			headers: { Accept: "application/json", "Content-Type": "application/json" },
			method: "POST",
			mode: "cors",
			cache: "default",
			body: vDATAS,
		}).then((response)=> { if (response.status === 200) {setSessionaktif(false); return response.json();} })
		.then((output_string) => {
			setSessionaktif(true);
			setLoading(false);
			uElBtndlgsimpan.disabled = false;

			if(output_string.sukses) {
				uDatamainArr.splice(vObjdx,1);
				setTabelRowSelect(-1);
				setJmlData((parseInt(uDatamainArr.length)||0));
				setEfekview(!uEfekview);
				hdlToggleForm();
			} else if(output_string.info) {
				showToast(output_string.info);
			} else if(output_string.errors) {
				console.log("("+uComponentname+"-"+uFuncname+") output_string.errors : "+output_string.errors);
				const vMsg = (pjson.mydefault.environment==="development")
					? output_string.errors : pjson.mydefault.msgFetchError;
				showToast(vMsg,"ERROR");
			} else if(output_string.expired) {
				uElBtndlgsimpan.disabled = true;
				setLoading(true);
				prosesExpired();
			}
		})
		.catch((error) =>{
			uElBtndlgsimpan.disabled = false;
			setLoading(false);
			console.log("("+uComponentname+"-"+uFuncname+") catch-error: "+error);
			showToast(pjson.mydefault.msg500str.join(" "),"ERROR");
		});
	}
	//---END API_FUNC--/

	//---EFFECT--/
	React.useEffect(()=>{});//-->EFFECT_DIULANG_TERUS_TIAP_ONCHANGE_DI_PAGE--/
	React.useEffect(()=>{//--JIKA_PAGINATION_DIATUR_BACKEND--/
		//console.log("("+uComponentname+"-[uTabelSelectObj]) uTabelSelectObj = "+(uTabelSelectObj));
		if(!uIsInitbefore) return;

		const vPageinit	= parseInt(uTabelSelectObj.initPage)||1;
		setPageActive(vPageinit); apiLoaddata(vPageinit);
	},[uIsInitbefore]);
	React.useEffect(()=>{
		setShowForm(false);
		if((uTokenObj.userinit||"") === "")
			{ prosesExpired(); return; }

		uDispatch({type: "set", effectApp: !uEfekapp});
		uDispatch({type: "set", gUrlbefore: window.location.pathname + window.location.search});

		if(!uIsInitbefore) { apiLoaddata(); } 

		return()=>{ setDatamainArr([]); }
	},[]);
	React.useEffect(()=>{
		if(!uInitbeforeprocess) return;

		const vInitID	= uTabelSelectObj.initID;
		const vRowIdx	= UFunc.getTabelRowIndeks("idtabeldata","idtr"+vInitID);
		setTabelRowSelect(vRowIdx);
		
		const vElscroll	= document.getElementById("idtr"+(vInitID||0));
		const vRectdimensi = vElscroll && (vElscroll.getBoundingClientRect());
		vRectdimensi && (window.scrollTo({ top: (vRectdimensi.top||0) - 150, behavior: "smooth" }))
		//console.log("(Pasien - [uInitselectedObj]) vRectdimensi => "+JSON.stringify(vRectdimensi))

		setInitbeforeprocess(false)
		uDispatch({type: "set", gInitTabelSelected: {}}); 
	},[uInitbeforeprocess]);
	React.useEffect(()=>{
		if(!uElJmldata) return;

		initJmldata();
	},[uElJmldata])
	React.useEffect(()=>{
		initJmldata();
		//console.log("(Kastransfer - [uJmlData]) uJmlData => "+uJmlData)

		let vJmlHal	= Math.ceil(uJmlData / uMaxData);
		setJmlHal(vJmlHal);//-*/
		setPageActive(uPageActive<=0?1:uPageActive);
	},[uJmlData]);
	/*React.useEffect(()=>{
		//console.log("("+uComponentname+"[uIsScrollBottom]) uIsScrollBottom: "+uIsScrollBottom);
		if(!isMobile) return;
		if(!uIsScrollBottom) return;

		const vPageNow	= uPageActive;
		if(vPageNow+1 > uJmlHal) return;
		setPageActive(vPageNow+1);
	},[uIsScrollBottom]);//-*/
	React.useEffect(()=>{
		if(!uHandelView) return;

		uHeaderActionObj.isHeaderView = false;
		uDispatch({type: "set", gInitHeaderAction: uHeaderActionObj});

		initReset();

		if(uPageActive > 1) setPageActive(1);
		else apiLoaddata()
	},[uHandelView]);
	React.useEffect(()=>{
		if(!uHandelTambah) return;

		uHeaderActionObj.isHeaderTambah = false;
		uDispatch({type: "set", gInitHeaderAction: uHeaderActionObj});

		if(uHTMLError500) return;

		uNavigate("/subkeuangan/kastransfer/forminput");
	},[uHandelTambah]);
	React.useEffect(()=>{
		if(!isShowForm) { initFormAwal(); return; }
		
		let vTimeout = setTimeout(() => {
			clearTimeout(vTimeout);
			setElBtndlgsimpan(document.getElementById("btnDialogSimpan"));
		},350);
	},[isShowForm]);
	React.useEffect(()=>{ 
		if(uFirstload==="YA") return;

		setTabelIDPilih(0);
		setTabelRowSelect(-1);
		const vDatapageArr = uDatamainArr.filter(
			vItems=>parseInt(vItems.pg||1)===parseInt(uPageActive||1));
		if(vDatapageArr.length > 0) { 
			window.scrollTo({ top: 0, behavior: "smooth" });
			return;
		}

		apiLoaddata(uPageActive);
	},[uPageActive]); //-->Unselect_ROW 
	//---END EFFECT--/

	//console.log("("+uComponentname+") Checked..");//---KALO_GA_ADA_YG_PAKE_uComponentname
	if(UFunc.isEmpty(uTokenObj)) { setLoading(true); prosesExpired(); return (<></>); }
	if(uHTMLError500) return (<MyPage500 content={uHTMLError500} {...props}/>)
	
	return (
		<>
		<div className="d-none">setDatamainArr = {JSON.stringify(uDatamainArr)}</div>
		<div className="d-none">uIsEOMExecuted = {uIsEOMExecuted.toString()}</div>
		<CCard className="classcardbg">
			<CCardHeader className="d-flex justify-content-between align-items-center">

			<small className="text-primary">
				<span className="d-md-none fw-bolder">
				{(()=>{
					const vKeyword = uKeywordObj.kwd_payroll || "";
					if(vKeyword.length < 3) {
						return (<>&#8734;</>)
					}

					return "("+UFunc.formatAngka(uJmlData)+")"
				})()}
				</span>
				<span className="d-none d-lg-block">{uBahasaObj.caption_rekapinput||"Rekap Input"}</span>
			</small>
			<div className="d-lg-none"/>
			<div className="text-muted classfontsmaller"><small>{UFunc.formatAngka(uTimeElapsed)}ms</small></div>
			</CCardHeader>
			
			<CCardBody className="px-0">{contentMain()}</CCardBody>

			{(uJmlData > uMaxData) && (
			<CCardFooter>
				<MyPagination
					activePage={uPageActive}
					pages={uJmlHal}
					onActivePageChange={(i) => setPageActive(i)}/>
			</CCardFooter>
			)}
		</CCard>

		<MyFormHapus
			value={uInpKeterangan}
			onCHvalue={(e)=>setInpKeterangan(e.target.value)}
			onSimpan={()=>hdlKlikSimpanHapus()}
			show={isShowForm} 
			dialogHeader={uDialogHeader}
			toggle={hdlToggleForm}/>
		</>
	)//>
}
	
export default Kastransfer;
